import Axios from "axios"

export const axios = function (config){
    let configCom = {
        method: config.method || "get",
        headers: {},
        ...config,
    }
    if (!("authorization" in config) || config.authorization) {
        // 不带authorization或设为true则加入jwt
        const token = window.localStorage.getItem("token")
        configCom.headers["Authorization"] = `${token || ""}`
    }
    return new Promise((resolve, reject) => {
        Axios(configCom)
            .then((res) => {
                resolve(res)
            })
            .catch((err) => {
                reject(err)
            })
    })
}

// 获取资源 arraybuffer
export const fetchArrayBufferByUrl = async function (url) {
    const res = await Axios.get(url, { responseType: "arraybuffer" });
    return res.data;
}

// 获取资源文本
export const fetchTextByUrl = function (url) {
    return Axios.get(url, { responseType: "text" });
}
